import { fileUpload } from './storageUtils';

/** 附件大小上限：20MB */
export const ADJUSTMENT_ATTACHMENT_MAX_SIZE_BYTES = 20 * 1024 * 1024;

/**
 * 附件 usage 前缀（对象键第一段）。
 * 独立前缀便于后续单独配置 S3 lifecycle，清理「上传后审批被驳回」产生的孤儿对象。
 */
export const ADJUSTMENT_ATTACHMENT_USAGE_TAG = 'settlement-adjustment-attachment';

/**
 * 调账附件草稿：文件已直传 S3，此处只保留元数据。
 * 每条调账最多一个附件，重新上传即覆盖。
 */
export interface AdjustmentAttachmentDraft {
  /** antd Upload 的行标识 */
  uid: string;
  /** S3 对象键（不存 URL：私有桶的下载地址是分钟级预签名，存下来会立即失效） */
  objectKey: string;
  fileName: string;
  fileSize: number;
  contentType?: string;
}

export const formatAttachmentSize = (bytes: number): string => {
  if (!bytes || bytes <= 0) return '-';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/**
 * 校验待上传文件。格式不限，只限制大小。
 * @returns 错误提示；通过校验时返回 null
 */
export const validateAdjustmentAttachment = (file: File): string | null => {
  if (file.size > ADJUSTMENT_ATTACHMENT_MAX_SIZE_BYTES) {
    return `附件不能超过 ${ADJUSTMENT_ATTACHMENT_MAX_SIZE_BYTES / 1024 / 1024}MB，当前 ${formatAttachmentSize(file.size)}`;
  }
  if (file.size <= 0) {
    return '不能上传空文件';
  }
  return null;
};

/**
 * 上传调账附件到私有桶（预签名直传，不经过后端）
 * @returns 附件草稿（uid 由调用方按 antd Upload 的 file.uid 传入）
 */
export const uploadAdjustmentAttachment = async (
  file: File,
  uid: string
): Promise<AdjustmentAttachmentDraft> => {
  const { objectKey } = await fileUpload(file, ADJUSTMENT_ATTACHMENT_USAGE_TAG);
  return {
    uid,
    objectKey,
    fileName: file.name,
    fileSize: file.size,
    contentType: file.type || undefined,
  };
};
